<script lang="ts" setup>
import MSplitScreen from "../MSplitScreen";

defineProps<{
  vertical?: boolean;
  value?: object | boolean;
  itemClass?: string;
}>();
</script>
<template>
  <div class="m-page-layout">
    <div class="flex-none">
      <slot v-if="vertical" name="toolbar"></slot>
    </div>

    <m-split-screen
      :model-value="value"
      :vertical="vertical"
      :item-class="itemClass"
      @input="$emit('input', $event)"
    >
      <slot v-if="!vertical" name="toolbar"> </slot>
      <slot />
      <template #item-title="itemBind">
        <slot name="item-title" v-bind="itemBind" />
      </template>

      <template #item="itemBind">
        <slot name="item" v-bind="itemBind" />
      </template>
    </m-split-screen>
  </div>
</template>

<style lang="scss">
.m-page-layout {
  display: flex;
  flex: 1 1 auto;

  flex-direction: column;

  margin: 16px 32px;
}
</style>
